import {
  Component,
  Input,
  OnChanges, OnDestroy, OnInit,
  SimpleChanges
} from '@angular/core';

@Component({
    selector: 'app-number-counter',
    templateUrl: './number-counter.component.html',
    styleUrls: ['./number-counter.component.scss'],
    standalone: false
})
export class NumberCounterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() digit: number;
  @Input() isDecimal: boolean = false;
  @Input() showPercentSymbol: boolean = false;
  currentValue: number = 0;
  allAnimators: any = [];
  initialized: boolean = false;

  timer: number = 100;

  animate() {
    if(this.isDecimal) {
      this.digit = parseFloat( ( this.digit ).toFixed( 2 ) );
      this.timer = 10;
    }
    if(this.currentValue == this.digit) {
      //don't reanimate if no change. Important because never ending count bug
    } else if(this.currentValue > this.digit) { //reduced, count backwards
      const countUpStop:any = setInterval(()=>{
        if(!this.isDecimal) {
          this.currentValue--;
        } else {
          this.currentValue = parseFloat((this.currentValue - 0.10).toFixed(2)) ;
        }
        if(this.currentValue <= this.digit)
        {
          clearInterval(countUpStop);
        }

      },this.timer)
      this.allAnimators.push(countUpStop);
    } else { //count
      const countDownStop:any = setInterval(()=>{
        if(!this.isDecimal) {
          this.currentValue++;
        } else {
          this.currentValue = parseFloat((this.currentValue + 0.10).toFixed(2)) ;
        }
        if(this.currentValue  >= this.digit)
        {
          clearInterval(countDownStop);
        }

      },this.timer)
      this.allAnimators.push(countDownStop);
    }
  }

  ngOnInit() {
    this.currentValue = this.digit;
    this.initialized = true;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes["digit"] && this.initialized) {
      this.allAnimators.forEach(item => { clearInterval(item); });
      this.animate();
    }
  }

  ngOnDestroy() {
    this.allAnimators.forEach(item => { clearInterval(item); });
  }

}
